import { lazy } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { Routes, SyncHook } from '../route-types';

// Lazy load the HospitalizationsPage component
const HospitalizationsPage = lazy(() =>
  import('../../../hospitalizations/components/HospitalizationsPage').then(
    module => ({
      default: module.default,
    })
  )
);

export const HOSPITALIZATIONS_PREFIX_PATH = '/hospitalizations';

const routes: Routes = [
  {
    path: HOSPITALIZATIONS_PREFIX_PATH,
    element: <HospitalizationsPage />,
  },
];

const useSyncHook: SyncHook = () => {
  return;
};

const useNavigationHooks = () => {
  const navigate = useNavigate();

  return {
    toHospitalizations: (options?: NavigateOptions) => {
      navigate(HOSPITALIZATIONS_PREFIX_PATH, options);
    },
  };
};

export const hospitalizationRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
